import axios from 'axios'
import { ApiResponse, AsessFilterDto } from '../models/Base'
import { TableDto } from '../models/dto/SelfAssessment'
import { JobDto, JobFilterRequestDto, JobRequestDto } from '../models/dto/Job'
import { SystemDateSaveFormat } from '../state/types'
import moment from 'moment'
import { Helper } from '..'
 

const API_URL = process.env.REACT_APP_API_URL
const ACTION_API_URL = `${API_URL}/job-assesses`


export function GetById(payload: number) {
    return axios.get<ApiResponse<JobDto>>(`${ACTION_API_URL}/${payload}`)
}

export function Search(payload: JobFilterRequestDto) {
    return axios.post<ApiResponse<TableDto>>(`${ACTION_API_URL}/search`, payload)
}

export function Create(payload: JobRequestDto) {
    return axios.post(`${ACTION_API_URL}`, payload)
}

export function Update(id: number, payload: JobRequestDto) {
    return axios.put(`${ACTION_API_URL}/${id}`, payload)
}

export function Summary(payload:JobFilterRequestDto) {
    return axios.post<ApiResponse<TableDto>>(`${ACTION_API_URL}/categories-summary`, payload)
}

export function GetLastHr(date:Date) {    

    return axios.get<ApiResponse<number>>(`${ACTION_API_URL}/last-hour/${moment(date).format(SystemDateSaveFormat)}`)
}
